import api from "../../services/api";

const useModules = () => {
  const list = async (params) => {
    const { data } = await api.request({
      url: "/modules",
      method: "GET",
      params,
    });
    return data;
  };

  const save = async (payload) => {
    const { data } = await api.request({
      url: "/modules",
      method: "POST",
      data: payload,
    });
    return data;
  };

  const update = async (payload) => {
    const { data } = await api.request({
      url: `/modules/${payload.id}`,
      method: "PUT",
      data: payload,
    });
    return data;
  };

  const remove = async (id) => {
    const { data } = await api.request({
      url: `/modules/${id}`,
      method: "DELETE",
    });
    return data;
  };

  const getPlanModules = async (planId) => {
    const { data } = await api.request({
      url: `/plans/${planId}/modules`,
      method: "GET",
    });
    return data;
  };

  const updatePlanModules = async (planId, modules) => {
    const { data } = await api.request({
      url: `/plans/${planId}/modules`,
      method: "PUT",
      data: { modules },
    });
    return data;
  };

  const getCompanyModules = async (companyId) => {
    const { data } = await api.request({
      url: `/companies/${companyId}/modules`,
      method: "GET",
    });
    return data;
  };

  const updateCompanyModules = async (companyId, modules) => {
    const { data } = await api.request({
      url: `/companies/${companyId}/modules`,
      method: "PUT",
      data: { modules },
    });
    return data;
  };

  const listAiPackages = async (params) => {
    const { data } = await api.request({
      url: "/ai/packages",
      method: "GET",
      params,
    });
    return data;
  };

  const saveAiPackage = async (payload) => {
    const { data } = await api.request({
      url: "/ai/packages",
      method: "POST",
      data: payload,
    });
    return data;
  };

  const updateAiPackage = async (payload) => {
    const { data } = await api.request({
      url: `/ai/packages/${payload.id}`,
      method: "PUT",
      data: payload,
    });
    return data;
  };

  const removeAiPackage = async (id) => {
    const { data } = await api.request({
      url: `/ai/packages/${id}`,
      method: "DELETE",
    });
    return data;
  };

  const getCompanyAiUsage = async (companyId) => {
    const { data } = await api.request({
      url: `/companies/${companyId}/ai/usage`,
      method: "GET",
    });
    return data;
  };

  const addCompanyAiCredits = async (companyId, payload) => {
    const { data } = await api.request({
      url: `/companies/${companyId}/ai/credits`,
      method: "POST",
      data: payload,
    });
    return data;
  };

  return {
    list,
    save,
    update,
    remove,
    getPlanModules,
    updatePlanModules,
    getCompanyModules,
    updateCompanyModules,
    listAiPackages,
    saveAiPackage,
    updateAiPackage,
    removeAiPackage,
    getCompanyAiUsage,
    addCompanyAiCredits,
  };
};

export default useModules;
